import { BASE_URL } from '../config/environment';

export const getImageUrl = (imagePath) => {
  if (!imagePath) return null;
  
  if (imagePath.startsWith('http')) {
    return imagePath;
  }
  
  return `${BASE_URL}${imagePath}`;
};

export const hideBrokenImage = (event) => {
  const image = event.currentTarget;
  image.onerror = null;
  image.src = 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(
    '<svg xmlns="http://www.w3.org/2000/svg" width="640" height="360"><rect width="100%" height="100%" fill="#dbeafe"/><text x="50%" y="50%" dominant-baseline="middle" text-anchor="middle" fill="#1d4ed8" font-family="Arial" font-size="28">FBRSTAPP</text></svg>'
  );
};
